import React from 'react'
import { Helmet } from 'react-helmet-async'
import { motion } from 'framer-motion'
import { Shield, Lock, Eye, FileText, Users, Globe, AlertCircle } from 'lucide-react'

const PrivacyPolicy: React.FC = () => {
  const sections = [
    {
      title: '1. 引言',
      icon: FileText,
      content: [
        
        'DeepLink Limited（"我们"、"本公司"）是一家根据香港法律注册成立的公司，注册地址为香港中环国际金融中心二期。',
        '本隐私政策说明我们如何收集、使用、存储和保护您的个人资料，并符合香港《个人资料（私隐）条例》（第486章）的规定。',
        '使用我们的服务即表示您同意本隐私政策的条款。如果您不同意，请停止使用我们的服务。'
      ]
    },
    {
      title: '2. 个人资料收集',
      icon: Eye,
      content: [
        '我们收集您主动提供的个人资料，包括但不限于：姓名、电邮地址、电话号码、邮寄地址等联系方式',
        '我们收集您使用CoreTrust手机及相关服务时产生的技术资料，如设备标识符、IP地址、使用日志等',
        '我们收集您与我们互动时产生的资料，如咨询记录、客户服务记录、反馈意见等',
        '我们可能收集您的财务资料，如支付信息，仅用于处理交易',
        '我们不会收集您的敏感个人资料，除非获得您的明确同意或法律要求'
      ]
    },
    {
      title: '3. 资料使用目的',
      icon: Globe,
      content: [
        '为您提供CoreTrust手机及相关Web3服务',
        '处理您的咨询、申请、订单和客户服务请求',
        '改进我们的产品和服务质量',
        '向您发送重要的产品更新、服务通知和营销信息（如您同意接收）',
        '进行市场调研和数据分析（采用匿名化处理）',
        '履行法律义务和监管要求',
        '保护我们的合法权益和防止欺诈'
      ]
    },
    {
      title: '4. 资料保护措施',
      icon: Shield,
      content: [
        '我们采用符合香港个人资料私隐专员公署指引的技术和组织措施保护您的个人资料',
        '使用业界标准的加密技术保护资料传输和存储',
        '实施访问控制和权限管理，限制员工对个人资料的访问',
        '定期进行安全审计、漏洞检测和风险评估',
        '建立数据泄露应急响应机制和通知程序',
        '对员工进行个人资料保护培训',
        '与第三方服务提供商签订数据保护协议'
      ]
    },
    {
      title: '5. 资料共享和披露',
      icon: Users,
      content: [
        '我们不会向第三方出售、出租或交易您的个人资料',
        '我们仅在以下情况下共享您的个人资料：',
        '• 获得您的明确同意',
        '• 法律要求或法院命令',
        '• 与可信的合作伙伴共享必要资料以提供服务（已签订数据保护协议）',
        '• 在业务转让、合并或重组时转移资料',
        '• 保护我们的合法权益或防止欺诈',
        '所有资料共享都遵循最小化原则和目的限制原则'
      ]
    },
    {
      title: '6. 您的权利',
      icon: Lock,
      content: [
        '根据香港《个人资料（私隐）条例》，您享有以下权利：',
        '• 查阅权：要求我们提供您个人资料的副本',
        '• 更正权：要求我们更正不准确的个人资料',
        '• 删除权：要求我们删除您的个人资料（在特定情况下）',
        '• 撤回同意权：撤回您之前给予的同意',
        '• 数据可携权：要求我们以结构化格式提供您的个人资料',
        '• 反对权：反对我们处理您的个人资料',
        '如需行使上述权利，请通过contact@deeplink.hk联系我们'
      ]
    },
    {
      title: '7. 资料保留',
      icon: FileText,
      content: [
        '我们仅在实现收集目的所需的时间内保留您的个人资料',
        '一般而言，客户资料保留期为7年（符合香港法律要求）',
        '技术资料和日志通常保留12个月',
        '营销资料在您撤回同意后立即删除',
        '法律要求保留的资料将按法律规定期限保留',
        '超过保留期限的资料将被安全销毁或匿名化处理'
      ]
    },
    {
      title: '8. 跨境资料传输',
      icon: Globe,
      content: [
        '我们可能将您的个人资料传输到香港以外的地方进行处理',
        '跨境传输将遵循香港个人资料私隐专员公署的指引',
        '我们确保接收方提供适当的保护措施',
        '传输前会进行充分的风险评估',
        '如需要，我们会获得您的明确同意',
        '我们不会向不提供充分保护的国家或地区传输资料'
      ]
    },
    {
      title: '9. 未成年人保护',
      icon: Shield,
      content: [
        '我们不会故意收集13岁以下儿童的个人资料',
        '如发现收集了儿童资料，我们将立即删除',
        '13-18岁未成年人的资料收集需要家长或监护人同意',
        '我们特别重视保护未成年人的隐私权',
        '如您是未成年人，请在家长或监护人指导下使用我们的服务'
      ]
    },
    {
      title: '10. 政策更新',
      icon: AlertCircle,
      content: [
        '我们可能会不时更新本隐私政策',
        '重大变更将通过电邮或网站公告通知您',
        '继续使用我们的服务即表示您接受更新后的政策',
        '建议您定期查看本政策的最新版本',
        '如您不同意更新后的政策，可以停止使用我们的服务'
      ]
    }
  ]

  return (
    <>
      <Helmet>
        <title>隐私政策 - DeepLink Limited</title>
        <meta name="description" content="DeepLink Limited隐私政策，符合香港个人资料（私隐）条例规定" />
      </Helmet>

      <div className="min-h-screen bg-gray-50 dark:bg-gray-900 py-12">
        <div className="container mx-auto px-4">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="max-w-4xl mx-auto"
          >
            <div className="text-center mb-12">
              <h1 className="text-4xl font-bold text-gray-900 dark:text-white mb-4">
                隐私政策
              </h1>
              <p className="text-gray-600 dark:text-gray-400 mb-4">
                最后更新：2024年1月1日 | 生效日期：2024年1月1日
              </p>
              <div className="bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg p-4 max-w-2xl mx-auto">
                <p className="text-sm text-blue-800 dark:text-blue-200">
                  <strong>重要提示：</strong>本隐私政策适用于香港特别行政区，并遵循《个人资料（私隐）条例》（第486章）的规定。
                </p>
              </div>
            </div>

            <div className="space-y-8">
              {sections.map((section, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, delay: index * 0.1 }}
                  className="bg-white dark:bg-gray-800 rounded-lg shadow-lg p-6"
                >
                  <div className="flex items-center mb-4">
                    <div className="w-10 h-10 bg-blue-100 dark:bg-blue-900/30 rounded-lg flex items-center justify-center mr-4">
                      <section.icon className="w-5 h-5 text-blue-600 dark:text-blue-400" />
                    </div>
                    <h2 className="text-2xl font-semibold text-gray-900 dark:text-white">
                      {section.title}
                    </h2>
                  </div>
                  <div className="space-y-3">
                    {section.content.map((item, itemIndex) => (
                      <p key={itemIndex} className="text-gray-700 dark:text-gray-300 leading-relaxed">
                        {item}
                      </p>
                    ))}
                  </div>
                </motion.div>
              ))}
            </div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.8 }}
              className="mt-12 bg-gray-100 dark:bg-gray-800 rounded-lg p-6"
            >
              <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
                联系我们
              </h3>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                如果您对本隐私政策有任何疑问或需要行使您的权利，请通过以下方式联系我们：
              </p>
              <div className="space-y-2">
                <p className="text-gray-700 dark:text-gray-300">
                  <strong>电邮：</strong> privacy@deeplink.hk
                </p>
                <p className="text-gray-700 dark:text-gray-300">
                  <strong>电话：</strong> +852 1234-5678
                </p>
                <p className="text-gray-700 dark:text-gray-300">
                  <strong>地址：</strong> 香港中环国际金融中心二期
                </p>
                <p className="text-gray-700 dark:text-gray-300">
                  <strong>个人资料私隐专员：</strong> 如您对我们的处理不满意，可以向香港个人资料私隐专员公署投诉
                </p>
              </div>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </>
  )
}

export default PrivacyPolicy